<template>
	<div class="w-100">
		<!-- HEADER -->
		<div class="mb-3">
			<p class="mb-0 mt-3 body-2-2 text-16 font-bold">{{$t('hotel.concierge.booked-room-list')}}</p>
			<!-- <p class="mb-0 body-2 font-regular">You're the leader of this booking. Please select your room and if you want to share this form with your friends or family who will use the specific room, please copy the link according to the name of the room type.</p> -->
			<p class="mb-0 body-2 font-regular">{{$t('hotel.concierge.leader-booking')}}</p>
		</div>
		<div v-if="copy_result.success" class="px-3 py-2 border radius-0 text-center d-block mb-3" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
      <p class="mb-0 body-3-1">{{$t('general.link-copied')}}</p>
    </div>
    <ErrorMessage :message="$t('hotel.concierge.claim-or-share-room')" />
		<div class="bg-light-page border rounded-6">
			<template v-for="(room_parent) in data">
				<div class="p-3 border-bottom">
					<p class="mb-0 body-2-2 text-14 font-bold">{{room_parent.name}}</p>
				</div>
				<div v-for="(room,room_index) in room_parent.detail_list" class="pl-4 pr-2 py-2 border-bottom">
					<div class="row no-gutters">
						<div class="col-1 align-self-center">
							<p class="mb-0 body-2-2 text-14 font-semibold">{{room_index+1}}. </p>
						</div>
						<div class="align-self-center" :class="room.guest_profile == null || room.status == 'NEW_RESERVATION'? 'col-8' : 'col-11'">
							<p v-if="room.room == null" class="mb-0 body-3-1 text-danger w-100 font-weight-bold">Unallocated Room</p>
							<p v-else class="mb-0 body-3-1 text-orange w-100 font-weight-bold">[{{room.room.name}}]</p>
							<p class="text-green mb-0 body-2-2 text-14 font-semibold text-truncate" v-if="room.guest_profile != null"><span v-if="getConciergeAuth().folio == room.folio_number" class="font-weight-bold">({{$t('general.you')}})</span> {{room.guest_profile.name}}</p>
							<p class="mb-0 body-2-2 text-14" v-else><i>{{$t('hotel.concierge.data-not-filled-in')}}</i></p>
							<!-- <p class="text-green mb-0 body-2-2 text-14 font-semibold text-truncate" v-if="guest.is_filled"><span v-if="is_leader && guest.id == booking_leader.id" class="font-weight-bold">(You)</span> {{guest.data.name}}</p> -->
							<!-- <p class="mb-0 body-2-2 text-14" v-else><i>Data not filled in</i></p> -->
						</div>
						<div class="col-3 align-self-center" v-if="room.guest_profile == null || room.status == 'NEW_RESERVATION'">
							<router-link v-if="getConciergeAuth().pin== '' && getConciergeAuth().folio == ''" :to="`/${getMerchant().code}/concierge/precheckin-form/${room.pms_detail_id}?booking_number=${booking_number}&token=${token}`">
								<div style="width:45%;" class="d-block body-3-3 text-green border-green rounded text-center cursor-pointer w-100 mb-1">
									{{$t('hotel.action.claim')}}
								</div>
							</router-link>
							<div @click="copyLink(room)" style="width:45%;" class="d-block w-100 body-3-3 text-orange border-orange rounded px-2 text-center cursor-pointer">
								{{$t('hotel.action.share')}}
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>

	</div>
</template>
<script>
	import config from '@/config/index.js'
	import {mapGetters,mapMutations} from 'vuex'
	export default{
		props: ['data'],
		data(){
			return{
				booking_leader: {},
				copy_result:{
					success: false,
					timer: 0
				}
			}
		},
		computed:{
			show_copy_result(){
				return this.copy_result.success
			},
			is_leader(){
				return Object.keys(this.booking_leader).length > 0 ? true : false
			},
			booking_number(){
				return this.$route.params.booking_number
			},
			token(){
				return this.$route.query.token
			}
		},
		watch:{
			show_copy_result(){
				if (this.show_copy_result) {
          let looping = setInterval(() => {
            if (this.copy_result.timer > 0) {
              this.copy_result.timer--
            }else if(this.copy_result.timer == 0){
              this.copy_result.success = false
              clearInterval(looping)
            }
          },1000) 
        }
			}
		},
		methods:{
			...mapGetters(['getMerchant','getConciergeAuth']),
			copyLink(data){
				// let full_url = config.BASE_APP_URL+this.getMerchant().code+"/concierge-precheckin-form/XYZ/XYZ/"+room_id+'/'+pin
				let full_url = `${config.BASE_APP_URL+this.getMerchant().code}/concierge/precheckin-form/${data.pms_detail_id}?booking_number=${this.booking_number}&token=${this.token}`
				let message = `${this.$t('hotel.concierge.msg-share-precheckin.desc_1')} ${data.room_type.name} ${this.$t('hotel.concierge.msg-share-precheckin.desc_2')} ${this.getMerchant().name}. ${this.$t('hotel.concierge.msg-share-precheckin.desc_3')} : ${full_url}`

				var input_temp = document.createElement("input");
        input_temp.value = message;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.copy_result.success = true
        this.copy_result.timer = 1
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/RoomList.vue